export default class Care {
  constructor(context) {
    this.dom = {
      body: context,
      instructions: context.querySelectorAll('.instruction'),
      addToCarts: context.querySelectorAll('.atc'),
    };

    this.mountAtcListeners();
    this.mountReadMoreListener();
  }

  mountAtcListeners() {
    const { addToCarts } = this.dom;
    addToCarts.forEach((atc) => {
      atc.addEventListener('click', (e) => {
        e.preventDefault();

        const id = atc.dataset.variant;
        const event = new CustomEvent('cart:requestStarted');
        const header = document.querySelector('.site-header');
        const navIcon = header.querySelector(
          '.vue-portal-target .site-header__cart a'
        );

        if (id) {
          const action = '/cart/add.js';
          fetch(action, {
            method: 'POST',
            quantity: 1,
            id: id.toString(),
          }).then(() => {
            alert('Success!');
            document.dispatchEvent(event);
            if (navIcon) {
              navIcon.click();
            }
          });
        }
      });
    });
  }

  mountReadMoreListener() {
    const { instructions } = this.dom;
    instructions.forEach((inst) => {
      const readMore = inst.querySelector('.read-more');

      readMore?.addEventListener('click', () => {
        if (inst.classList.contains('expanded')) {
          inst.classList.remove('expanded');
        } else {
          inst.classList.add('expanded');
        }
      });
    });
  }
}
